import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { CQAppConstant } from "../../../../app-constants";
import { ActionType, CQCombobox, IOption } from "../../../../common/cq-inputs";
import { BaseClassDataStore } from "../../../../store/base-class-store";
import { CQAppStore } from "../../../../store/cq-app-store";
import { CQMasterDataStore } from "../../../../store/cq-master-data.store";
import { IFieldData } from "../../component-level-fields/component-field";

interface IProps {
    fieldData: IFieldData;
    templateName: string; //most probably use context
}

const CQBaseClassName = (props: IProps) => {
    const {
        fieldData: { inputParamKey },
        templateName,
    } = props;

    const outputConfigObject = CQMasterDataStore.OutputConfig.getStoreData(templateName);
    const objectName: string =
    outputConfigObject.selectedObject;
    const layoutName: string = 
    outputConfigObject.selectedLayout;

    const [state, setState] = useState<string>(outputConfigObject[inputParamKey] || 'cqRecordForm');
    const [dropDownList, setDropdownList] = useState<IOption[]>(() => ([{ label: "cqRecordForm", value: "cqRecordForm", id: '1' }]));

    useEffect(() => {
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(
            templateName,
            inputParamKey,
            state
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    useEffect(() => {
        const dropDowns = fetchDropDownData() || [];

        let dropDownValues = getComboBoxValues(
            Object.values(dropDowns),
            state
        );

        if(dropDownValues.length > 0) {
            setDropdownList(dropDownValues);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [layoutName, objectName]);

    function fetchDropDownData() {
        try{
            const baseClassObject = BaseClassDataStore.BaseClassObject[0];
            const classObjects = baseClassObject.objects;
            const objectKeys = Object.keys(baseClassObject.objects);
            let inputParamKeyObject: any = {};
            objectKeys.forEach((objKey: string) => {
                if (
                    classObjects[objKey].hasOwnProperty(inputParamKey) &&
                    objectName === objKey
                ) {
                    inputParamKeyObject = {
                        ...inputParamKeyObject,
                        ...classObjects[objKey][inputParamKey],
                    };
                }
            });

            inputParamKeyObject = {
                ...inputParamKeyObject,
                [baseClassObject.defaultclassName]: baseClassObject.defaultclassName,
            };

            return inputParamKeyObject;
        } catch (error : any) {

            CQAppStore.loader.setVisibility(false);
            const errorObj = {
                errorType: CQAppConstant.ERROR_CUSTOM,
                errorMessage: error.error ? error.error : error.message,
                errorStatus: error.status,
                componentName: ''
            };
            CQAppStore.error.dispatchError(errorObj);
        }
    }

    function getComboBoxValues(dropDownValues: any, fieldValue: string) {
        let formattedComboBoxValues: IOption[] = [];
        if (fieldValue) {
            formattedComboBoxValues = dropDownValues.map(
                (item: string, index: number) => {
                    return {
                        label: item,
                        value: item,
                        id: `${index + 1}`,
                    };
                }
            );
        }
        return formattedComboBoxValues;
    }

    const valueChange = (value: string) => {
        setState(value);
    };

    function onActionPerformed(actionType: ActionType, result: IOption[] | string) {
        if(actionType === 'item-cleared' || actionType === 'item-selected') {
            if(typeof(result) !== "string"){
                valueChange(result.length === 0 ? '' : result[0].value);
            }
        }else if(actionType === 'text-changed'){
            valueChange(result as string);
        }
    }

    return (
        <CQCombobox
            key= {inputParamKey}
            value={outputConfigObject[inputParamKey]}
            label={{
                label: "",
                placeholder: "",
            }}
            onActionPerformed={(actionType, result) => onActionPerformed(actionType, result as IOption[])}
            options={dropDownList}
            limit={dropDownList.length}
            config={{
                variation: 'inline-listbox',
            }}
        />
    );
};

export default observer(CQBaseClassName);
